import { FDLozenge } from '@facet-wealth/design';
import React from 'react';
import { inputDefaultProps, inputPropTypes } from 'Packages/FacetDesign/Components/propTypes';
import PropTypes from 'prop-types';
import { useDataAttrs } from 'Helpers/Testing';
import { buildUseStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';


const useStyles = buildUseStyles('Lozenge', ((theme) => ({
  root: {
    '& > div': {
      backgroundColor({ color }) {
        if (color === 'primary') {
          return theme.palette.facet.oceana800;
        }
        if (color === 'subtle') {
          return theme.palette.facet.stone500;
        }
        return undefined;
      },
      color({ color }) {
        if (color === 'primary') {
          return theme.palette.common.white;
        }
        if (color === 'subtle') {
          return theme.palette.facet.oceana800;
        }
        return undefined;
      },
    },
  },
})));

const Lozenge = (props) => {
  const {
    size,
    value,
    alignSelf,
    color,
    ...rest
  } = props;
  const classes = useStyles({ color });
  const dataAttrs = useDataAttrs(rest);

  if (!value) return null;

  return (
    <div className={classes.root}>
      <FDLozenge
        {...dataAttrs}
        label={value}
        size={size}
        alignSelf={alignSelf}
        color={color === 'primary' || color === 'subtle' ? 'info' : color}
      />
    </div>
  );
};

Lozenge.defaultProps = {
  alignSelf: inputDefaultProps.alignSelf,
  value: undefined,
  color: 'info',
};

Lozenge.propTypes = {
  alignSelf: inputPropTypes.alignSelf,
  size: inputPropTypes.size.isRequired,
  value: PropTypes.string,
  color: PropTypes.oneOf(['error', 'info', 'success', 'warning', 'primary', 'subtle']),
};

const LozengeSmall = (props) => {
  return <Lozenge {...props} size="sm" />;
};

const LozengeLarge = (props) => {
  return <Lozenge {...props} size="lg" />;
};

export { LozengeSmall, LozengeLarge };
